import { useState, useRef, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import uploadApi from '_api/upload'
import { updateGroup } from '_redux/modules/group'
import { extractDominantColor } from '_utils/imageColor'

export default function useChangeImage({ groupId, groupById, isAdmin = false } = {}) {
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const [avatarPreview, setAvatarPreview] = useState('')
  const [accentColor, setAccentColor] = useState('#009A97')
  const [isUploading, setIsUploading] = useState(false)
  const fileInputRef = useRef(null)

  const currentPhoto = avatarPreview || groupById?.photoUrl

  const handleAvatarClick = () => {
    if (!isAdmin || isUploading) return
    fileInputRef.current?.click()
  }

  const onUserImageUploaded = async (_event) => {
    const { files } = _event.target
    if (files && files[0]) {
      const img = files[0]
      setAvatarPreview(URL.createObjectURL(img))

      try {
        setIsUploading(true)
        const { msgResp: res } = await uploadApi.uploadPhoto(files)
        const photoUrl = res?.url
        if (photoUrl) {
          const targetId = groupId || groupById?.id || groupById?.gid
          await dispatch(
            updateGroup({
              id: targetId,
              postData: { photoUrl },
            })
          )
          setAvatarPreview(photoUrl)
          addToast('Update group image successfully', { appearance: 'success', autoDismiss: true })
        }
      } catch (error) {
        setAvatarPreview('')
        addToast(error?.msgResp || 'Failed to update image', { appearance: 'error', autoDismiss: true })
      } finally {
        setIsUploading(false)
      }
    }
  }

  useEffect(() => {
    let isMounted = true
    if (currentPhoto) {
      extractDominantColor(currentPhoto, '#009A97').then((color) => {
        if (isMounted && color) {
          setAccentColor(color)
        }
      })
    } else {
      setAccentColor('#009A97')
    }

    return () => {
      isMounted = false
    }
  }, [currentPhoto])

  return {
    fileInputRef,
    currentPhoto,
    accentColor,
    isUploading,
    handleAvatarClick,
    onUserImageUploaded,
  }
}
